import { useQrGenerator } from './useQrGenerator';

export const useQrGeneratorGateways = () => {
  const { downloadGateways, isLoading } = useQrGenerator();

  return { download: downloadGateways, isLoading }
}